import useStyles from "./useStyles";

const LegendContent = (props) => {
  const { payload } = props;
  
  const classes = useStyles();

  return (
    <ul
      className={classes.ulContainer}
    >
      {payload.map(({ value, color }, index) => (
        <li
        className={classes.liContent}
          key={`item-${index}`}
        >
          {value}
          <svg
            class={classes.rechartSurface}
            viewBox="0 0 32 32"
            fill={color}
          >
            <title></title>
            <desc></desc>
            <path
              stroke="none"
              fill={color}
              d="M0 0 1000 2 0 32z"
              class="recharts-legend-icon"
            ></path>
          </svg>
        </li>
      ))}
    </ul>
  );
};

export default LegendContent;
